import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "739.238",
  height: "738.444",
  viewBox: "0 0 195.59 195.38",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M193.145 41.52c-.814-2.443-3.663-2.85-5.699-1.222l-32.97 32.971c-2.443 2.442-6.513 2.442-8.956 0l-23.202-23.202c-2.442-2.442-2.442-6.513 0-8.955l33.379-32.971c1.628-1.628.814-4.478-1.222-5.699C148.777.814 142.671 0 136.972 0c-34.599 0-62.278 29.715-58.208 65.128.814 5.699 2.035 10.583 4.07 15.468L6.717 156.307c-8.955 8.955-8.955 23.61 0 32.157 4.478 4.478 10.584 6.92 16.282 6.92s11.805-2.442 16.282-6.92l75.712-75.711c4.884 2.035 10.176 3.256 15.467 4.07 35.414 4.07 65.128-23.609 65.128-58.208 0-6.106-.814-11.804-2.442-17.096z" }, null, -1)
  ]))]))
}
export default { render };